const browserGlobal = globalThis as typeof globalThis & {
  global?: typeof globalThis;
};

if (typeof browserGlobal.global === 'undefined') {
  browserGlobal.global = browserGlobal;
}
